module.exports = __webpack_public_path__ + "img/favicon2.3c2e8e7a.jpg";